import script from "./TargetaInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TargetaInfo.vue?vue&type=script&setup=true&lang=js"

import "./TargetaInfo.vue?vue&type=style&index=0&id=4caeb714&lang=css"

const __exports__ = script;

export default __exports__